<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-card>
	   			<v-card-title>

            <v-text-field v-model="filter.code" label="Order ID" class="mr-3"></v-text-field>
            
            <v-autocomplete v-if="hasAdminPrivilage || isShippingManager || isSalesManager" v-model="filter.status" :items="statuses" item-text="title" item-value="id" label="Status" class="mr-3"></v-autocomplete>

            <v-autocomplete v-if="(hasAdminPrivilage || isSalesManager) && filter.type !== config.invoiceTypes.franchisee" :loading="franchiseeLoading" v-model="filter.retailer" :search-input.sync="franchiseeSearchText" :items="franchisees" item-text="title" item-value="id" label="Branch Name" hide-no-data class="mr-3" clearable>
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                  <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
            
            <v-autocomplete v-if="hasAdminPrivilage || isSalesManager" v-model="filter.type" :items="types" item-text="title" item-value="id" label="Type" class="mr-3"></v-autocomplete>

            <v-autocomplete v-if="(hasAdminPrivilage || isSalesManager) && filter.type == config.invoiceTypes.customer" :loading="customerLoading" v-model="filter.customer" :search-input.sync="customerSearchMobile" :items="customers" item-text="mobile" item-value="id" label="Customer Mobile" hide-no-data class="mr-3">
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                  <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>

            <v-autocomplete v-if="(hasAdminPrivilage || isSalesManager) && filter.type == config.invoiceTypes.customer" :loading="customerLoading" v-model="filter.customer" :search-input.sync="customerSearchText" :items="customers" item-text="title" item-value="id" label="Customer Name" hide-no-data class="mr-3">
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                  <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>

            <v-autocomplete v-if="(hasAdminPrivilage || isSalesManager) && filter.type == config.invoiceTypes.franchisee" :loading="franchiseeLoading" v-model="filter.franchisee" :search-input.sync="franchiseeSearchText" :items="franchisees" item-text="title" item-value="id" label="Franchisee Name" hide-no-data>
            </v-autocomplete>

            <search-btn @click="filterData" />

            <v-spacer></v-spacer>

			    </v-card-title>
          
          <v-list two-line v-if="isMobileApp">
            <v-divider></v-divider>
            <template v-for="(item, index) in items">
              <sales-list-item :key="item.code" :item="item" @confirmShip="confirmShipItem" @confirmDelivery="confirmDeliveryItem" />
            </template>
          </v-list>
	   			
          <v-data-table v-else
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <tr is="sales-list-item" :item="props.item" @confirmCancel="confirmCancelItem" @confirmShip="confirmShipItem" @confirmDelivery="confirmDeliveryItem"></tr>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

			</v-card>
   		</v-flex>

      <action-dialog action="cancel" :status="cancelDialog" @close="closeCancelDialog" @success="cancelInvoice" />
      <!-- <action-dialog action="ship" :status="shipDialog" @close="closeShipDialog" @success="shipInvoice" /> -->
      <action-dialog action="deliver" :status="deliveryDialog" @close="closeDeliveryDialog" @success="deliverInvoice" />

      <v-dialog v-model="shipDialog" max-width="350px" persistent v-if="shippingItem">
        <v-card>
          <v-card-title>
            <span class="headline">Confirm Shipping</span>
          </v-card-title>
          <v-card-text>
            <v-autocomplete :loading="shippingStaffLoading" :search-input.sync="shippingStaffSearchText" v-model="shippingItem.shipping_staff" :items="shippingStaffs" item-text="first_name" item-value="id" label="Shipping Staff" hide-no-data></v-autocomplete>
          </v-card-text>

          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat small :disabled="processing" @click.prevent="closeShipDialog">Cancel</v-btn>
            <v-btn color="blue darken-1" flat small :disabled="processing || (shippingItem && !shippingItem.shipping_staff)" :loading="processing" @click.prevent="shipInvoice">Ship Order</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

   	</v-layout>
    
  </v-flex>
</template>

<script>

  const deviceType = process.env.VUE_APP_IS_MOBILE.toString() === 'true' ? 'Mobile' : ''

  export default {
    name: 'SalesList',
    data () {
      return {
      	title: "Sales List",
      	processing: false,
      	items: [],
        headers: [
          { text: 'Order ID', value: 'code'},
          { text: 'Order Date', value: 'added_time'},
          { text: 'Order Type', value: 'type', sortable: false},
          { text: 'Customer/Franchisee', value: 'customer_name', sortable: false},
          { text: 'Branch', value: 'retailer_name'},
          // { text: 'Sub Total (Rs.)', value: 'total', align: 'right'},
          // { text: 'Discount (Rs.)', value: 'discount', align: 'right'},
          // { text: 'GST (Rs.)', value: 'tax', align: 'right'},
          { text: 'Total (Rs.)', value: 'grandtotal', align: 'right'},
          { text: 'Status', value: 'status', align: 'center', sortable: false },
          { text: 'Actions', value: 'id', sortable: false }
        ],
        cancellingItem: null,
        cancelDialog: false,
        shippingItem: null,
        shipDialog: false,
        deliveringItem: null,
        deliveryDialog: false,
        filter: {
          type: "",
          code: "",
          customer: "",
          franchisee: "",
          retailer: "",
          confirmed: true,
          status: ""
        },
        types: [
          {
            id: "",
            title: "All"
          }
        ],
        statuses: [
          {
            id: "",
            title: "All"
          }
        ],
        customerLoading: false,
        customerSearchText: "",
        customerSearchMobile: "",
        customers: [],
        franchiseeLoading: false,
        franchiseeSearchText: "",
        franchisees: [],
        shippingStaffs: [],
        shippingStaffLoading: false,
        shippingStaffSearchText: ""
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Sales',
	          disabled: true
	        },
	        {
	          text: 'List',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Sales')
    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getInvoices.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)

        if (this.isShippingManager && !this.filter.status) {
          this.filter.status = [this.config.invoiceStatus.approved, this.config.invoiceStatus.shipped, this.config.invoiceStatus.delivered]
        }
        else if(this.isShippingStaff) {
          this.filter.status = [this.config.invoiceStatus.shipped, this.config.invoiceStatus.delivered]
        }
          
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          if (val) {
            filterArray.push(`${key}=${val}`)
          }
        }

        if (filterArray.length) {
          api_path += '?' + filterArray.join('&')
        }
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      searchShippingStaffs () {
        let api_path = this.config.apis.searchShippingStaffs
        if (this.shippingStaffSearchText) {
          api_path += `?first_name=${this.shippingStaffSearchText}`
        }

        this.shippingStaffLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.shippingStaffLoading = false
            if (this.isSuccessResponse(response)) {
              this.shippingStaffs = response.data.data
            }
        })
        .catch((error) => {
            this.shippingStaffLoading = false
        })
      },

      searchCustomers (params) {
        
        let api_path = this.config.apis.getCustomers.replace(":page", 1).replace(":perPage", this.paginationOptions.rowsPerPage)

        api_path += params

        this.customerLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.customerLoading = false
            if (this.isSuccessResponse(response)) {
              this.customers = response.data.data.items
            }
        })
        .catch((error) => {
            this.customerLoading = false
        })

      },

      searchCustomersByName () {

        let param = `?title=${this.customerSearchText}`

        this.searchCustomers(param)

      },

      searchCustomersByMobile () {

        let param = `?mobile=${this.customerSearchMobile}`

        this.searchCustomers(param)
      },

      searchFranchisees () {
        this.franchiseeLoading = true
        this.axios.get(`${this.config.apis.searchRetailers}?title=${this.franchiseeSearchText}`)
        .then((response) => {
            this.franchiseeLoading = false
            if (this.isSuccessResponse(response)) {
              this.franchisees = response.data.data
            }
        })
        .catch((error) => {
            this.franchiseeLoading = false
        })
      },

      confirmCancelItem (item) {
        this.cancellingItem = item
        this.cancelDialog = true
      },

      closeCancelDialog () {
        this.cancellingItem = null
        this.cancelDialog = false
      },

      cancelInvoice () {
        
        if (!this.cancellingItem) return

        this.processing = true
        this.axios.put(this.config.apis.cancelInvoice.replace(":id", this.cancellingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.cancellingItem.status = this.config.invoiceStatus.cancelled

              this.notifySuccess('updateSuccess')
              this.closeCancelDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeCancelDialog()
          })
      },

      confirmShipItem (item) {
        this.shippingItem = item
        this.shipDialog = true
      },

      closeShipDialog () {
        this.shippingItem = null
        this.shipDialog = false
      },

      shipInvoice () {

        if (!this.shippingItem) return

        let data = { shipping_staff: this.shippingItem.shipping_staff }

        this.processing = true
        this.axios.put(this.config.apis.shipInvoice.replace(":id", this.shippingItem.id), data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.shippingItem.status = this.config.invoiceStatus.shipped

              this.notifySuccess('updateSuccess')
              this.closeShipDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeShipDialog()
          })
      },

      confirmDeliveryItem (item) {
        this.deliveringItem = item
        this.deliveryDialog = true
      },

      closeDeliveryDialog () {
        this.deliveringItem = null
        this.deliveryDialog = false
      },

      deliverInvoice () {

        if (!this.deliveringItem) return

        this.processing = true
        this.axios.put(this.config.apis.deliverInvoice.replace(":id", this.deliveringItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.deliveringItem.status = this.config.invoiceStatus.delivered

              this.notifySuccess('updateSuccess')
              this.closeDeliveryDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeDeliveryDialog()
          })
      }

    },
    mounted () {
      
      for (const [key, val] of Object.entries(this.config.invoiceTypes)) {
        this.types.push({id: val, title: key})
      }

      for (const [key, val] of Object.entries(this.config.saleStatus)) {
        if (this.isShippingManager && val == this.config.saleStatus.confirmed) {
          continue
        }
        this.statuses.push({id: val, title: key})
      }
      
    },

    computed: {

    },

    watch: {

      customerSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchCustomersByName()
        }
      },

      customerSearchMobile (val, oldVal) {
        if (val && val != oldVal) {
          this.searchCustomersByMobile()
        }
      },

      franchiseeSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchFranchisees()
        }
      },

      shippingStaffSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchShippingStaffs()
        }
      },

      'filter.type' (val) {
        
        this.filter.franchisee = ""
        this.filter.customer = ""

        if (val === this.config.invoiceTypes.franchisee) {
          this.filter.retailer = ""
        }
      },

      'filter.retailer' (val) {

        if (!val) {
          this.filter.retailer = ""
        }
      }

    },
    
    components: {
      'sales-list-item': () => import(`./SalesListItem${deviceType}`)
    }

  }
</script>

<style scoped>
  .mobile-app .v-card__title {
    padding-top: 0;
    padding-bottom: 0;
  }
</style>
